import { theme } from '@theme';
import { SortDirection } from '../enums/SortDirection';

export const useSortingIndicator = (): SortingIndicatorReturnType => {
  const getColor = (direction: SortDirection, iconType: string): string => {
    if (iconType === 'down') {
      switch (direction) {
        case SortDirection.None:
          return theme.palette.sortIndicatorGray;

        case SortDirection.Ascending:
          return theme.palette.sortIndicatorGray;

        case SortDirection.Descending:
          return theme.palette.white;

        default:
          return theme.palette.sortIndicatorGray;
      }
    } else {
      switch (direction) {
        case SortDirection.None:
          return theme.palette.sortIndicatorGray;

        case SortDirection.Descending:
          return theme.palette.sortIndicatorGray;

        case SortDirection.Ascending:
          return theme.palette.white;

        default:
          return theme.palette.sortIndicatorGray;
      }
    }
  };

  return { getColor };
};

type SortingIndicatorReturnType = {
  getColor(direction: SortDirection, iconType: string): string;
};
